export default {
  updateOptions(state, payload) {
    state.options = { ...state.options, ...payload }
  },
}
